module.exports = __webpack_public_path__ + "img/640a117cdcc68480065335c96ba411a7.png";